module.exports = __webpack_public_path__ + "img/card-3.1ea2d77f.png";